// AWS Cognito Hosted UI login — follow-up to docs/design.md §13.
// Redirects the browser to Cognito's own hosted login page (Authorization
// Code flow); the callback (AuthCallback.tsx) hands the returned `code` to
// the backend's /api/v1/auth/cognito/exchange, which holds the client
// secret and does the actual token exchange server-side.

const DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN as string | undefined;
const CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined;
const REDIRECT_URI = (import.meta.env.VITE_COGNITO_REDIRECT_URI as string | undefined)
  || `${window.location.origin}/login/callback`;

let warnedMissingConfig = false;

export function isCognitoConfigured(): boolean {
  const configured = Boolean(DOMAIN && CLIENT_ID);
  if (!configured && !warnedMissingConfig) {
    warnedMissingConfig = true;
    const missing = [!DOMAIN && "VITE_COGNITO_DOMAIN", !CLIENT_ID && "VITE_COGNITO_CLIENT_ID"]
      .filter(Boolean)
      .join(", ");
    console.warn(
      `[cognito] AWS Cognito login is disabled: missing ${missing}. ` +
      "These must be set as build-time env vars when the frontend bundle is built."
    );
  }
  return configured;
}

export function redirectToHostedUi(): void {
  if (!DOMAIN || !CLIENT_ID) {
    throw new Error("VITE_COGNITO_DOMAIN / VITE_COGNITO_CLIENT_ID are not configured.");
  }
  const params = new URLSearchParams({
    client_id: CLIENT_ID,
    response_type: "code",
    scope: "email profile openid phone",
    redirect_uri: REDIRECT_URI,
  });
  window.location.href = `https://${DOMAIN}/login?${params.toString()}`;
}

export function getRedirectUri(): string {
  return REDIRECT_URI;
}
